export default __webpack_public_path__ + "images/water-table-depth.svg";